import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthModal } from './AuthModal';

export const Auth = () => {
  const [isOpen, setIsOpen] = useState(true);
  const navigate = useNavigate();

  const handleClose = () => {
    setIsOpen(false);
    navigate('/');
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="absolute inset-0 bg-black/20 backdrop-blur-[2px]" />
      <div className="relative">
        <AuthModal isOpen={isOpen} onClose={handleClose} />
      </div>
    </div>
  );
}; 